import axiosInstance from 'api/axiosInstance';
import { stringify } from 'query-string';
import type { IPaginationRequest, Paging } from 'types/pagination.types';
import type { DocumentItem } from 'types/repository.types';

type DocumentResponse = { paging: Paging; data: DocumentItem[] };
const getRepoDocuments = (
  params: IPaginationRequest & { opened?: boolean },
): Promise<DocumentResponse> =>
  axiosInstance
    .get<any, DocumentResponse & { repositoryDocuments: DocumentItem[] }>(
      `/v2/repository-documents?${stringify(params, {
        skipEmptyString: true,
        arrayFormat: 'comma',
      })}`,
    )
    .then(({ repositoryDocuments, paging }) => ({
      data: repositoryDocuments,
      paging,
    }));

export default getRepoDocuments;
